import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NodeService } from '../../services/node-service/node-service.service';
import { PointOfInterest } from '../categories/categories.model';
import { PoiProfileService } from '../poi-profile/poi-profile.service';

@Component({
  selector: 'app-edit-poi-view',
  templateUrl: './edit-poi-view.component.html',
  standalone: false,
})
export class EditPoiViewComponent implements OnInit {
  title: string = 'Editar punto de interés';
  showForm: boolean = false;
  parentIdValue: number = 0;

  constructor(
    private nodeService: NodeService,
    public route: ActivatedRoute,
    private poiProfileService: PoiProfileService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.parent?.params.subscribe((params) => {
      let poiId = parseInt(params['poiId']);

      this.poiProfileService.getPoi(poiId).subscribe(({ body }) => {
        const response = body?.body ?? body;
        const pois = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
            ? response.data
            : Array.isArray(response?.body)
              ? response.body
              : response?.id !== undefined
                ? [response]
                : [];
        const poiToEdit = pois.find((poi: PointOfInterest) => poi.id === poiId);

        if (poiToEdit) {
          this.parentIdValue = poiToEdit.categoryId ?? 0;
          this.title = `Editar ${poiToEdit.nombre}`;
          this.nodeService.setPoiToEdit(poiToEdit);
          this.showForm = true;
          this.cdr.detectChanges();
        }
      });
    });
  }
}
